import React from 'react';
import ProductCounter from '../ProductCounter/ProductCounter';
import Style from './ShoppingList.module.css';
import { errorToast, succToast } from '../../Toast/Toast';
import { UpdateProductCountInBasket } from '../../Api/BarestServices';
import { separate } from '../../Seprate/Seprate';

const ShoppingList = (props) => {
  const countHandler = (e) => {
    let idList = {
      supplier_id: props.supplierId,
      product_id: props.List.id,
      count: e,
    };
    UpdateProductCountInBasket(idList, (res) => {
      if (res.status === 1) {
        succToast('با موفقیت بروزرسانی شد');
        props.onclickforce();
      } else {
        errorToast(res.message);
      }
    });
  };

  const unitPrice = parseInt(
    props.List.off_price > 0 ? props.List.off_price : props.List.price || 0,
    10
  );
  const totalPrice = props.List.count * unitPrice;

  return (
    <li className={Style.ShoppingList}>
      {/* Top on Mobile: Product Name & Info */}
      <div className={Style.productInfo}>
        <p className={Style.productName}>
          {props.List.name}
          {!props.HideCounter && props.Count ? (
            <span className={Style.countBadge}>({props.Count})</span>
          ) : null}
        </p>
        {props.List.off_price > 0 && props.List.price && (
          <span className={Style.unitPriceHint}>
            قیمت واحد: {separate(props.List.off_price)} تومان
          </span>
        )}
      </div>

      {/* Bottom on Mobile / Side on Desktop: Counter and Total Price */}
      <div className={Style.productActions}>
        {!props.HideCounter ? (
          <div className={Style.counterContainer}>
            <ProductCounter
              maxCount={props.List.max_count}
              CountProduct={props.List.count}
              GetCount={countHandler}
            />
          </div>
        ) : <div />}

        <div className={Style.priceContainer}>
          <span className={Style.priceTotal}>{separate(totalPrice)}</span>
          <small className={Style.priceUnit}>تومان</small>
        </div>
      </div>
    </li>
  );
};

export default ShoppingList;
